import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=8c00ce28"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports